import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectUserProfileById } from '@ninety/platform/state/app-entities/users/users-state.selectors';
import { USER_PROFILE_PROVIDER, UserProfileProvider } from '@ninety/ui/core';

/**
 * Binds {@link USER_PROFILE_PROVIDER}, consumed by `ContactCardContainerComponent` in `@ninety/ui/core`,
 * to `selectUserProfileById` — the exact factory selector the component used to read itself. The
 * component stays free of `@ninety/platform/state` (no build target, so it cannot be compiled into the
 * public package), which makes this composition root the single place that depends on both sides.
 *
 * `CONTACT_CARD_ENABLED_STREAM`, which `ContactCardHoverDirective` in the same family consumes, is
 * deliberately NOT bound here — `USER_SELECT_PROVIDERS` already binds it to
 * `selectFeatureFlag(FeatureFlagKeys.enableContactCard)`, and re-binding would let the last registration
 * silently win. (DEV-26530 part 16)
 */
export const CONTACT_CARD_PROVIDERS: Provider[] = [
  {
    provide: USER_PROFILE_PROVIDER,
    useFactory:
      (store: Store): UserProfileProvider =>
      userId =>
        store.select(selectUserProfileById(userId)),
    deps: [Store],
  },
];
